let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9XYQ9"), load("lhT1C"), load("kiGNy"), load("kDPsc"), load("i1IyX")]).then(() => parcelRequire('5xERy'));